import * as Yup from 'yup';
import { onlyDigits } from '../../../shared/regex/regex';
import { telephoneValidation, postcodeValidation } from 'utils/form/validation';
import { dateValidation } from 'utils/date';

const rulesForFirstStep = {
  fcaNumber: Yup.string()
    .typeError('FCA Number is invalid')
    .matches(onlyDigits, 'FCA Number is invalid')
    .test('len', 'FCA Number is invalid', (val) => val && val.length === 6)
    .required('FCA Number is mandatory'),
  networkName: Yup.string()
    .typeError('Name of Network is invalid')
    .test('len', 'Name of Network should contain minimum 2 characters', (val) => val && val.length > 1)
    .required('Name of Network is mandatory'),
  postCode: postcodeValidation().required('Post Code is mandatory'),
  houseNr: Yup.string()
    .typeError('Address Line 1 is invalid')
    .required('Address Line 1 is mandatory'),
  line1: Yup.string().typeError('Address Line 2 is invalid'),
  line2: Yup.string().typeError('Address Line 3 is invalid'),
  city: Yup.string()
    .typeError('Town/City is invalid')
    .test('len', 'Town/City should contain minimum 3 characters', (val) => val && val.length > 2)
    .required('Town/City is mandatory'),
  county: Yup.string().typeError('County is invalid'),
  email: Yup.string()
    .typeError('Email Address is invalid')
    .email('Email Address is invalid')
    .required('Email Address is mandatory'),
  phoneNumber: telephoneValidation().required('Telephone Number is mandatory'),
  submissionRoute: Yup.string()
    .nullable()
    .required('This field is required.'),
  commissionTerms: Yup.number().when('submissionRoute', {
    is: (val) => val === null || val === '' || val === 'Direct',
    then: Yup.number()
      .typeError('Commission term is invalid')
      .required('Commission term is mandatory'),
  }),
};

const directorAddressSchema = Yup.object().shape({
  postCode: postcodeValidation()
    .typeError('Post Code is invalid')
    .required('Post Code is required'),
  houseNr: Yup.string()
    .typeError('Line 1 is invalid')
    .required('Line 1 is required'),
  line1: Yup.string().typeError('Line 2 is invalid'),
  line2: Yup.string().typeError('Line 3 is invalid'),
  city: Yup.string()
    .typeError('Town/City is invalid')
    .min(3, 'Town/City should contain at least 3 characters')
    .required('Town/City is required'),
  county: Yup.string().typeError('County is invalid'),
  residentFrom: dateValidation().required('Resident from is required'),
});

const directorDetailsSchema = Yup.object().shape({
  title: Yup.string()
    .typeError('Title is invalid')
    .required('Title is required'),
  firstName: Yup.string()
    .typeError('First Name is invalid')
    .min(2, 'First Name should contain at least 2 characters')
    .required('First Name is required'),
  middleName: Yup.string().typeError('Middle Name(s) is invalid'),
  surname: Yup.string()
    .typeError('Surname is invalid')
    .min(2, 'Surname should contain at least 2 characters')
    .required('Surname is required'),
  dateOfBirth: dateValidation().required('Date of Birth is required'),
  gender: Yup.string()
    .typeError('Gender is invalid')
    .required('Gender is required'),
  addresses: Yup.array().of(directorAddressSchema),
});

export const validationSchemaForStep1 = Yup.object().shape(rulesForFirstStep);
export const validationSchemaForStep2 = Yup.object().shape({
  ...rulesForFirstStep,
  directors: Yup.array().of(directorDetailsSchema),
});
